import { GroupedTableColumn } from "../../common/components/functional/GroupedTable/GroupedTable";

export const NEW_ORDER_COLUMN_WIDTHS = {
  bundling: "40px",
  fillShift: "12px",
  manualOffer: "24px",
  workLocation: "unset",
  orderTemplate: "15%",
  amount: "10%",
  date: "168px",
  time: "158px",
  customerCostCenter: "12%",
  reasonForTemporaryEmployment: "15%",
  more: "40px",
  notification: "40px",
};

export enum OrderDialogMode {
  None = "",
  CancelRows = "cancelRows",
  CancelAssignment = "cancelAssignment",
  Edit = "edit",
  Search = "search",
  Disassemble = "disassemble",
}

export enum CancelAssignmentScope {
  Single = "single",
  Bundle = "bundle",
}

// Reasons for temporary employment

export const reasonForTemporaryEmploymentOptions = [
  { value: "AssignedWorkOrProject", label: "AssignedWorkOrProject" },
  { value: "ProductionPeak", label: "ProductionPeak" },
  { value: "Internship", label: "Internship" },
  { value: "Substitution", label: "Substitution" },
  { value: "SpecificOrder", label: "SpecificOrder" },
  { value: "Season", label: "Season" },
];

// Reasons for cancelling order and assignments

// Base reasons shared by multiple cancellation types
const BASE_CANCEL_REASONS = [
  { id: "CustomerNeedsChanged", value: "CustomerNeedsChanged" },
  { id: "TalentFoundInternally", value: "TalentFoundInternally" },
  { id: "TalentFoundFromPartner", value: "TalentFoundFromPartner" },
  { id: "IncorrectOrder", value: "IncorrectOrder" },
];

// Reasons for cancelling short order (entire order)
export const CANCEL_SHORT_ORDER_OPTIONS = [
  ...BASE_CANCEL_REASONS,
  { id: "ReplacedWithNewShift", value: "ReplacedWithNewShift" },
];

// Reasons for asking if replacement talent is needed
export const ASK_REPLACEMENT_TALENT_REASONS = [
  "UnsuitableTalent",
  "ReplacedWithNewShift",
  "TalentCancelledShift",
];

// Reasons for cancelling long order (entire order)
export const CANCEL_LONG_ORDER_OPTIONS = [
  ...BASE_CANCEL_REASONS,
  { id: "DirectRecruitment", value: "DirectRecruitment" },
];

export const ORDER_CANCELLED_ALL_SHIFTS_CANCELLED = "allShiftsCancelled";

// Reasons for cancelling assignment (shift)
export const CANCEL_ASSIGNMENT_OPTIONS = [
  ...BASE_CANCEL_REASONS,
  { id: "UnsuitableTalent", value: "UnsuitableTalent" },
  { id: "ReplacedWithNewShift", value: "ReplacedWithNewShift" },
  { id: "TalentCancelledShift", value: "TalentCancelledShift" },
];

// Order filter values

// With this, backend filters with all expert's own order queues
export const FILTER_QUEUE_OWN = { value: "own", translationKey: "queueOwn" };

// const FILTER_STATUS_ACTIVE = { value: "Active", translationKey: "active" };
const FILTER_STATUS_OPEN = { value: "Open", translationKey: "rowOpen" };
const FILTER_STATUS_FULFILLED = {
  value: "Fulfilled",
  translationKey: "fulfilled",
};
const FILTER_STATUS_CANCELLED = {
  value: "Cancelled",
  translationKey: "cancelled",
};

const FILTER_STATUS_OPEN_EXPIRED = {
  value: "OpenExpired",
  translationKey: "openExpired",
};

export const FILTER_ORDER_ALL_SHIFTS = {
  value: "AllShifts",
  translationKey: "allShortOrders",
};
const FILTER_ORDER_SINGLE_SHIFT = {
  value: "SingleShift",
  translationKey: "singleShift",
};
const FILTER_ORDER_BUNDLED = {
  value: "ShiftBundle",
  translationKey: "shiftBundle",
};
const FILTER_ORDER_FIXED_TERM = {
  value: "FixedTerm",
  translationKey: "fixedTerm",
};
const FILTER_ORDER_CONTINUOUS = {
  value: "Continuous",
  translationKey: "continuous",
};

const FILTER_URGENCY_FILL_SHIFT = {
  id: "fillShift",
  name: "fillShift",
};

export const FILTER_ORDER_STATUS = [
  // FILTER_STATUS_ACTIVE,
  FILTER_STATUS_OPEN,
  FILTER_STATUS_OPEN_EXPIRED,
  FILTER_STATUS_FULFILLED,
  FILTER_STATUS_CANCELLED,
];
export const FILTER_ORDER_TYPES = [
  FILTER_ORDER_ALL_SHIFTS,
  FILTER_ORDER_SINGLE_SHIFT,
  FILTER_ORDER_BUNDLED,
  FILTER_ORDER_FIXED_TERM,
  FILTER_ORDER_CONTINUOUS,
];
export const FILTER_ORDER_URGENCY = [FILTER_URGENCY_FILL_SHIFT];

// Talent offer statuses

export const TALENT_OFFER_OFFERED = "Offered";
export const TALENT_OFFER_NOT_OFFERED = "NotOffered";
export const TALENT_OFFER_ACCEPTED = "Accepted";
export const TALENT_OFFER_DECLINED = "Declined";

export const TALENT_OFFER_STATUSES = [
  TALENT_OFFER_OFFERED,
  TALENT_OFFER_NOT_OFFERED,
  TALENT_OFFER_ACCEPTED,
  TALENT_OFFER_DECLINED,
];

// Long order offer statuses

export const WORK_AGREEMENT_ACCEPTED = "ACCEPTED";
export const WORK_AGREEMENT_DECLINED = "DECLINED";

// Order statuses

export const ORDER_STATUS_EXPIRED = "Expired"; // Note: for long orders only, for now

// Order automatching and fulfillment statuses

export const AUTOMATCHING_ON = "On";
export const AUTOMATCHING_OFF = "Off";
export const AUTOMATCHING_PAUSED = "Paused";

export const FULFILLMENT_NONE = "None";
export const FULFILLMENT_NONE_FINISHED = "NoneFinished";
export const FULFILLMENT_PARTIAL = "Partial";
export const FULFILLMENT_PARTIAL_FINISHED = "PartialFinished";
export const FULFILLMENT_FULL = "Full";
export const FULFILLMENT_FULL_FINISHED = "FullFinished";

export const ORDER_FILTERS_LOCAL_STORAGE = "orderFilters";

export const ORDER_COLUMNS: GroupedTableColumn[] = [
  {
    fieldName: "date",
    displayName: "date",
    width: "10%",
    disableTooltip: true,
  },
  {
    fieldName: "time",
    displayName: "time",
    width: "10%",
    disableTooltip: true,
  },
  {
    fieldName: "customerOrgName",
    displayName: "customer",
    width: "15%",
    maxWidth: "200px",
  },
  {
    fieldName: "workLocationName",
    displayName: "workLocation",
    maxWidth: "220px",
    width: "20%",
  },

  {
    fieldName: "workTitle",
    displayName: "workTitle",
    maxWidth: "170px",
    width: "15%",
  },
  {
    fieldName: "fulfilledState",
    displayName: "fulfilled",
    width: "5%",
    disableTooltip: true,
  },
  {
    fieldName: "assignedTalents",
    displayName: "assignedTalent",
    width: "10%",
    flairComponent: true,
    disableTooltip: true,
  },
  {
    fieldName: "orderHandlers",
    displayName: "orderHandler",
    width: "10%",
    disableTooltip: false,
  },
  {
    fieldName: "more",
    displayName: "",
    width: "48px",
    disableTooltip: true,
    align: "center",
  },
];

export const OFFER_TO_OWN = "offerToOwn";
export const OFFER_FIRST_TO_OWN = "offerFirstToOwn";
